import { render, staticRenderFns } from "./Turtle.vue?vue&type=template&id=2775c794&"
import script from "./Turtle.vue?vue&type=script&lang=js&"
export * from "./Turtle.vue?vue&type=script&lang=js&"
import style0 from "./Turtle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Turtle.vue"
export default component.exports